<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2"
		><h3>APS Intake</h3></app-anchor
	>
	<h3 class="flex-1">/ Edit Law Firm</h3>
</div>
<app-container type="dark" class="mt-2">
	<app-create-company-side-form
		[minify]="false"
		(onSubmit)="onSubmit($event)"
		(onCancel)="onCancel()"
		[company]="lawFirm"
		[name]="lawFirm?.name"
	>
	</app-create-company-side-form>
</app-container>
